import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  setBannerAws,
  setBanner,
  setLogo,
  setLogoAws,
  setbackimageColor,
  updateFarmaciaInfo,
  changePassword,
  checkABuser,
} from "../api/userApi";
import "../css/EditProfile.css";

function EditarPerfil() {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const { token } = useAuth();
  const [bannerUrl, setBannerUrl] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [bannerFile, setBannerFile] = useState(null);
  const [logoFile, setLogoFile] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [nombre, setNombre] = useState(storedUser.farmacia.nombre);
  const [mail, setMail] = useState(storedUser.farmacia.mail);
  const [backColor, setBackColor] = useState(
    storedUser.farmacia.backgroundcolor || "#FAF6EC"
  );
  const [telefono, setTelefono] = useState(storedUser.farmacia.telefono || "");
  const [ab_id, setAbId] = useState(storedUser.farmacia.ab_id || "");
  // Mientras ab_id sea distinto al guardado y no se haya validado contra Alfabeta,
  // el botón de Actualizar datos queda grisado.
  const [originalAbId, setOriginalAbId] = useState(storedUser.farmacia.ab_id || "");
  const [abValidated, setAbValidated] = useState(true);
  const [validatingAb, setValidatingAb] = useState(false);
  const [showAbPasswordInput, setShowAbPasswordInput] = useState(false);
  const [abPassword, setAbPassword] = useState("");
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");

  const abChanged = ab_id !== originalAbId;
  const saveDisabled = abChanged && !abValidated;

  const handleAbIdChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setAbId(value);
    // Cualquier cambio en el usuario de Alfabeta invalida la validación previa
    setAbValidated(false);
    setShowAbPasswordInput(false);
    setAbPassword("");
  };

  const handleValidateAbId = () => {
    if (!ab_id) return;
    setShowAbPasswordInput(true);
  };

  const handleSubmitAbValidation = async () => {
    if (!abPassword) return;

    setValidatingAb(true);
    try {
      const res = await checkABuser(ab_id, abPassword, token);
      if (res.data && res.data.success) {
        setAbValidated(true);
        setStatus({
          type: "success",
          message: "Usuario de Alfabeta validado correctamente.",
        });
        setShowAbPasswordInput(false);
        setAbPassword("");
      } else {
        setAbValidated(false);
        setStatus({
          type: "error",
          message:
            (res.data && res.data.message) ||
            "No se pudo validar el usuario de Alfabeta.",
        });
      }
    } catch (error) {
      setAbValidated(false);
      setStatus({
        type: "error",
        message: "Error al validar el usuario de Alfabeta.",
      });
    } finally {
      setValidatingAb(false);
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleChangeFarmaciaInfo = async () => {
    if (!nombre || !mail) return;
    try {
      await updateFarmaciaInfo(
        nombre,
        mail,
        telefono ? Number(telefono) : null,
        ab_id ? Number(ab_id) : null,
        token
      );
      setStatus({
        type: "success",
        message: "Datos actualizados correctamente.",
      });
      storedUser.farmacia.nombre = nombre;
      storedUser.farmacia.mail = mail;
      storedUser.farmacia.telefono = telefono;
      storedUser.farmacia.ab_id = ab_id;
      localStorage.setItem("user", JSON.stringify(storedUser));
      setOriginalAbId(ab_id);
      setAbValidated(true);
    } catch (error) {
      setStatus({ type: "error", message: "Error al actualizar los datos." });
    }
  };

  const handleChangePassword = async () => {
    if (newPassword1 !== newPassword2 || !newPassword1) return;
    try {
      await changePassword(newPassword1, token);
      setStatus({
        type: "success",
        message: "Contraseña actualizada correctamente.",
      });
    } catch (error) {
      setStatus({ type: "error", message: "Error al cambiar la contraseña." });
    }
  };

  const handleSetBackgroundColor = async () => {
    if (!backColor) return;
    try {
      await setbackimageColor(backColor, token);
      setStatus({ type: "success", message: "¡Color de fondo actualizado!" });
      storedUser.farmacia.backgroundcolor = backColor;
      localStorage.setItem("user", JSON.stringify(storedUser));
    } catch (error) {
      setStatus({ type: "error", message: "Error al actualizar el color de fondo." });
    }
  };

  const handleBannerUrl = async () => {
    if (!bannerUrl) return;
    try {
      await setBanner(bannerUrl, token);
      setStatus({ type: "success", message: "¡Banner actualizado!" });
    } catch (error) {
      setStatus({ type: "error", message: "Error al subir el banner." });
    }
  };

  const handleLogoUrl = async () => {
    if (!logoUrl) return;
    try {
      await setLogo(logoUrl, token);
      setStatus({ type: "success", message: "¡Logo actualizado!" });
    } catch (error) {
      setStatus({ type: "error", message: "Error al subir el logo." });
    }
  };

  const handleLogoFileUpload = async () => {
    if (!logoFile) return;
    try {
      const base64 = await toBase64(logoFile);
      await setLogoAws(base64, token);
      setStatus({ type: "success", message: "¡Logo actualizado!" });
    } catch (error) {
      setStatus({ type: "error", message: "Error al subir el logo." });
    }
  };

  const handleBannerFileUpload = async () => {
    if (!bannerFile) return;
    try {
      const base64 = await toBase64(bannerFile);
      await setBannerAws(base64, token);
      setStatus({ type: "success", message: "¡Banner actualizado!" });
    } catch (error) {
      setStatus({ type: "error", message: "Error al subir el banner." });
    }
  };

  return (
    <div className="edit-container">
      <h2>Editar Perfil</h2>
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <a
          href="/CreateQR"
          style={{
            display: "inline-block",
            backgroundColor: "#1b4d1b", // verde oscuro
            color: "white",
            padding: "10px 20px",
            fontSize: "18px",
            fontWeight: "600",
            borderRadius: "6px",
            textDecoration: "none",
            border: "1.5px solid #145214",
            boxShadow: "none",
            transition: "background-color 0.3s ease",
            minWidth: "220px",
            textAlign: "center",
            userSelect: "none",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#145214")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "#1b4d1b")
          }
        >
          Generar tu QR
        </a>
      </div>

      {status.message && (
        <div className={`status-message ${status.type}`}>{status.message}</div>
      )}

      {/* Datos de farmacia */}
      <div className="section vertical-section">
        <h3>Información de la farmacia</h3>
        <label htmlFor="nombre">Nombre de la farmacia:</label>
        <input
          type="text"
          placeholder="Nombre de la farmacia"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
        />
        <label htmlFor="mail">Email:</label>
        <input
          type="email"
          placeholder="Email"
          value={mail}
          onChange={(e) => setMail(e.target.value)}
        />
        <label htmlFor="telefono">WhatsApp para recibir pedidos:</label>
        <input
          type="text"
          inputMode="numeric"
          id="telefono"
          placeholder="Ej: 5491122334455"
          value={telefono}
          onChange={(e) => setTelefono(e.target.value.replace(/\D/g, ""))}
        />
        <label htmlFor="ab_id">Usuario de Alfabeta (si lo tenés):</label>
        <p style={{ fontSize: "0.85rem", color: "#777", margin: "0 0 8px" }}>
          Si no tenés un usuario de webservice de Alfabeta, solicitalo
          directamente a Alfabeta antes de completarlo acá.
        </p>
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <input
            type="text"
            inputMode="numeric"
            id="ab_id"
            placeholder="Usuario de Alfabeta (opcional)"
            value={ab_id}
            onChange={handleAbIdChange}
            style={{ flex: 1 }}
          />
          <button
            type="button"
            onClick={handleValidateAbId}
            disabled={!ab_id}
          >
            Validar usuario
          </button>
        </div>
        {showAbPasswordInput && (
          <div style={{ display: "flex", gap: "8px", alignItems: "center", marginTop: "8px" }}>
            <input
              type="password"
              placeholder="Password provisto por Alfabeta"
              value={abPassword}
              onChange={(e) => setAbPassword(e.target.value)}
              style={{ flex: 1 }}
            />
            <button
              type="button"
              onClick={handleSubmitAbValidation}
              disabled={!abPassword || validatingAb}
            >
              {validatingAb ? "Validando..." : "Enviar"}
            </button>
          </div>
        )}
        <button onClick={handleChangeFarmaciaInfo} disabled={saveDisabled}>
          Actualizar datos
        </button>
        {saveDisabled && (
          <p style={{ fontSize: "0.85rem", color: "#a35b00", margin: "4px 0 0" }}>
            Validá el usuario de Alfabeta antes de guardar los cambios.
          </p>
        )}
      </div>

      {/* Cambiar contraseña */}
      <div className="section vertical-section">
        <h3>Cambiar contraseña</h3>
        <input
          type="password"
          placeholder="Nueva contraseña"
          value={newPassword1}
          onChange={(e) => setNewPassword1(e.target.value)}
        />
        <input
          type="password"
          placeholder="Repetir contraseña"
          value={newPassword2}
          onChange={(e) => setNewPassword2(e.target.value)}
        />
        <button
          onClick={handleChangePassword}
          disabled={!newPassword1 || newPassword1 !== newPassword2}
        >
          Actualizar contraseña
        </button>
      </div>

      {/* Color de fondo */}
      <div className="section vertical-section">
        <h3>Color de fondo</h3>
        <div style={{ display: "flex", gap: "16px", alignItems: "center", marginBottom: "15px" }}>
          <div
            style={{
              width: "56px",
              height: "56px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              backgroundColor: backColor,
              flexShrink: 0,
            }}
            title="Color actual"
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "0.85rem", color: "#777" }}>Color actual</span>
            <span style={{ fontSize: "0.95rem", fontWeight: 600, color: "#333" }}>
              {backColor}
            </span>
          </div>
        </div>
        <label htmlFor="backColor">Elegir nuevo color:</label>
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <input
            type="color"
            id="backColor"
            value={backColor}
            onChange={(e) => setBackColor(e.target.value)}
            style={{
              width: "48px",
              height: "40px",
              padding: "2px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <span style={{ fontSize: "0.9rem", color: "#555" }}>{backColor}</span>
        </div>
        <button type="button" onClick={handleSetBackgroundColor}>
          Guardar color
        </button>
      </div>

      {/* Subir desde archivo */}
      <div className="section horizontal-section">
        <h3>Subir imagen desde el dispositivo</h3>
        <div className="row">
          <div className="form-group">
            <label>Banner:</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setBannerFile(e.target.files[0])}
            />
            <button onClick={handleBannerFileUpload}>Subir banner</button>
          </div>

          <div className="form-group">
            <label>Logo:</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setLogoFile(e.target.files[0])}
            />
            <button onClick={handleLogoFileUpload}>Subir logo</button>
          </div>
        </div>
      </div>

      {/* Usar una URL */}
      <div className="section horizontal-section">
        <h3>Usar una URL</h3>
        <div className="row">
          <div className="form-group">
            <label>URL del banner:</label>
            <input
              type="text"
              value={bannerUrl}
              onChange={(e) => setBannerUrl(e.target.value)}
              placeholder="https://..."
            />
            <button onClick={handleBannerUrl}>Usar URL</button>
          </div>

          <div className="form-group">
            <label>URL del logo:</label>
            <input
              type="text"
              value={logoUrl}
              onChange={(e) => setLogoUrl(e.target.value)}
              placeholder="https://..."
            />
            <button onClick={handleLogoUrl}>Usar URL</button>
          </div>
        </div>
      </div>

      <div className="actions">
        <button className="back-button" onClick={() => navigate(-1)}>
          Volver
        </button>
      </div>
    </div>
  );
}

export default EditarPerfil;